/// /////////////////////////////////////////////////////////////////////////////////////
///                           Copyright (c) 2020 - 2021
///                            Coyote Logistics L.L.C.
///                          All Rights Reserved Worldwide
///
/// WARNING:  This program (or document) is unpublished, proprietary
/// property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
/// Unauthorized reproduction, distribution or disclosure of this program
/// (or document), or any program (or document) derived from it is
/// prohibited by State and Federal law, and by local law outside of the U.S.
/// //////////////////////////////////////////////////////////////////////////////////////

import React from "react";
import { Link } from "react-router-dom";

import messages from "../../../helpers/messages";

function SalesViewArchivedBidState() {
  return (
    <>
      <p className="inline-block font-size-14 pt-16 mb-0">
        {messages.bidHasBeenArchivedMessage.defaultMessage}
      </p>
      <Link to="/">
        <div className="fr py-8 my-2">
          <button
            className="text-button univers-67-bold-cond font-size-14 uppercase mx-8 h-32 short-button px-16"
            data-testid="return-home"
          >
            {messages.returnHome.defaultMessage}
          </button>
        </div>
      </Link>
    </>
  );
}

export default SalesViewArchivedBidState;
